import { Button } from '@curology/ui-components-web/react/Button';
import clsx from 'clsx';
import { useAtom } from 'jotai';
import React, { useState } from 'react';

import { FlashMessagesState } from '@/atoms/flashMessages/flashMessagesState';
import { useFlowContext } from '@/components/flow/hooks/useFlowContext';
import { useNavigation } from '@/components/flow/hooks/useNavigation';

import { processMultiRxUpsellPage } from '../../utils/utils';

const FooterCtas = ({
  upsell,
  isModalOpen,
}: {
  upsell: string;
  isModalOpen: boolean;
}) => {
  const { brand } = useFlowContext();
  const { onNext } = useNavigation();

  const [flashMessages, setFlashMessages] = useAtom(
    FlashMessagesState.flashMessagesAtom,
  );

  const [processing, setProcessing] = useState(false);

  return (
    <div
      className={clsx(
        'cur-bg-surface-neutral -cur-mx-4 -cur-mb-8 cur-bottom-0 cur-sticky',
        !isModalOpen && 'cur-z-[999999]',
      )}
    >
      <div className="cur-flex cur-max-w-[550px] cur-mx-auto cur-p-4">
        <div className="cur-flex-1">
          <div className="cur-pr-2">
            <Button
              buttonType="secondary"
              className="cur-w-full"
              disabled={processing}
              onClick={() =>
                processMultiRxUpsellPage({
                  brand,
                  upsell,
                  accepted: false,
                  onNext,
                  flashMessages,
                  setFlashMessages,
                  setProcessing,
                })
              }
            >
              Skip
            </Button>
          </div>
        </div>
        <div className="cur-flex-1">
          <div className="cur-pl-2">
            <Button
              className="cur-w-full"
              disabled={processing}
              onClick={() =>
                processMultiRxUpsellPage({
                  brand,
                  upsell,
                  accepted: true,
                  onNext,
                  flashMessages,
                  setFlashMessages,
                  setProcessing,
                })
              }
            >
              Upgrade for free
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterCtas;
